module.exports = [{
      plugin: require('/tmp/4fd17fc3/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
